import src from '../assets/greenboxindoorgolf.png';
import { imageLogo } from './imageLogo';

/**
 * Greenbox Indoor Golf — wordmark (opaque white ground, as delivered).
 * Was a raster wrapped in <svg><image> declaring a 500-unit canvas over a
 * 1024px file; the registry crop ('30 140 440 190', scaled 2.048x to pixels)
 * is now baked into the asset. 16KB quantized.
 */
export const GreenboxIndoorGolfLogo = imageLogo({
  src,
  width: 902,
  height: 389,
  alt: 'Greenbox Indoor Golf',
});
